import { cardsData } from '@/mocks/home';

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">分类频道</h2>
          <p className="text-foreground-600">按类型快速浏览，发现你感兴趣的影视内容</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {cardsData.map((card) => (
            <a
              key={card.id}
              href="#cards"
              className="group block bg-background-50 rounded-xl overflow-hidden border border-background-200/60 hover:border-primary-200/60 transition-all duration-300 cursor-pointer no-underline"
            >
              <div className="relative overflow-hidden" style={{ aspectRatio: '8/5' }}>
                <img
                  src={card.image}
                  alt={card.title}
                  title={`七七影院 ${card.title}`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 right-3">
                  <span className="px-2 py-0.5 rounded-full bg-accent-500 text-background-50 text-xs font-medium">{card.tag}</span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-semibold text-foreground-950 group-hover:text-primary-500 transition-colors mb-1.5">{card.title}</h3>
                <p className="text-xs text-foreground-600 leading-relaxed line-clamp-2">{card.desc}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}